import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class userManageState extends baseState {
	// 用户列表
	@observable list = {};
	@action
	setList = data => this.list = data;

	getList = data => {
		return this.fetch({
			url: apiUrl.USER_MANAGE.LIST,
			method: 'get',
			setState: "setList",
			data
		});
	}

	// 用户增删改
	insert = data => this.fetch({ url: apiUrl.USER_MANAGE.CREATE, method: 'post', data }); // 创建
	update = data => this.fetch({ url: apiUrl.USER_MANAGE.UPDATE, method: 'post', data }); // 更新
	delete = id => this.fetch({ url: apiUrl.USER_MANAGE.DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 用户详情
	@observable detail = {};
	@action
	setDetail = data => this.detail = data;

	getDetail = data => {
		const { id } = data;
		return this.fetch({
			url: apiUrl.USER_MANAGE.DETAIL + id,
			method: 'get',
			setState: "setDetail",
		});
	}

	// 用户详情显示已绑定设备
	@observable detailBindList = {};
	@action
	setDetailBindList = data => {
		// this.detailBindList = data;
		let obj = {};
		obj.records = data.tbDeviceWatchList || [];
		obj.total = data.tbDeviceWatchList ? data.tbDeviceWatchList.length : 0;
		let arr = obj.records || [];
		arr.map(item => {
			item.memberId = data.id;
		});
		obj.records = arr;
		this.detailBindList = obj;
	};

	getDetailBindList = data => {
		const { id } = data;
		return this.fetch({
			url: apiUrl.USER_MANAGE.DETAIL + id,
			method: 'get',
			setState: "setDetailBindList",
		});
	}

	// 用户绑定设备
	bindDevice = data => this.fetch({ url: apiUrl.USER_MANAGE.USER_DEVICE_BIND, method: 'post', data });

	// 用户解除绑定
	unbindDevice = data => this.fetch({ url: apiUrl.USER_MANAGE.USER_DEVICE_UNBIND, method: 'post', data });

	// 设备列表
	@observable deviceList = {};
	@action
	setDeviceList = data => this.deviceList = data;

	getDeviceList = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.LIST_ALL,
			method: 'get',
			setState: "setDeviceList",
			data
		});
	}


	// // 渠道列表
	// @observable deptList = [];
	// @action
	// setDeptList(data) {
	// 	this.deptList = data || [];
	// }
	// getDeptList = () => {
	// 	return this.fetch({
	// 		url: apiUrl.PERMISSION.USER.DEPT_LIST_ALL,
	// 		setState: this.setDeptList,
	// 		method: 'get',
	// 	});
	// };

	// // 品牌列表无分页
	// @observable brandList = [];
	// @action
	// setBrandList(data) {
	// 	this.brandList = data || [];
	// }
	// getBranList = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_BRAND_LIST,
	// 		setState: this.setBrandList,
	// 		method: 'get',
	// 	});
	// };

	// // 品牌列表分页
	// @observable brandListPage = [];
	// @action
	// setBrandListPage(data) {
	// 	this.brandListPage = data || [];
	// }
	// getBranListPage = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_BRAND_PAGE,
	// 		setState: this.setBrandListPage,
	// 		method: 'get',
	// 	});
	// };

	// 设备品牌增删改
	insertBrand = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_BRAND_ADD, method: 'post', data }); // 创建
	updateBrand = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_BRAND_UPDATE, method: 'post', data }); // 更新
	deleteBrand = id => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_BRAND_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 设置用户异常通知开关
	setSwitch = data => this.fetch({ url: apiUrl.USER_MANAGE.USER_SWITCH, method: 'post', data });

	// // 设备类型列表无分页
	// @observable categoryList = [];
	// @action
	// setCategoryList(data) {
	// 	this.categoryList = data || [];
	// }
	// getCategoryList = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_CATEGORY_LIST,
	// 		setState: this.setCategoryList,
	// 		method: 'get',
	// 	});
	// };

	// // 设备类型列表分页
	// @observable categoryListPage = [];
	// @action
	// setCategoryListPage(data) {
	// 	this.categoryListPage = data || [];
	// }
	// getCategoryListPage = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_CATEGORY_PAGE,
	// 		setState: this.setCategoryListPage,
	// 		method: 'get',
	// 	});
	// };

	// // 设备类型增删改
	// insertCategory = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_CATEGORY_ADD, method: 'post', data }); // 创建
	// updateCategory = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_CATEGORY_UPDATE, method: 'post', data }); // 更新
	// deleteCategory = id => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_CATEGORY_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// // 型号列表无分页
	// @observable modelList = [];
	// @action
	// setModelList(data) {
	// 	this.modelList = data || [];
	// }
	// getModelList = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_MODEL_LIST,
	// 		setState: this.setModelList,
	// 		method: 'get',
	// 	});
	// };

	// // 型号列表分页 
	// @observable modelListPage = [];
	// @action
	// setModelListPage(data) {
	// 	this.modelListPage = data || [];
	// }
	// getModelListPage = () => {
	// 	return this.fetch({
	// 		url: apiUrl.USER_MANAGE.DEVICE_MODEL_PAGE,
	// 		setState: this.setModelListPage,
	// 		method: 'get',
	// 	});
	// };

	// // 设备型号增删改
	// insertModel = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_MODEL_ADD, method: 'post', data }); // 创建
	// updateModel = data => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_MODEL_UPDATE, method: 'post', data }); // 更新
	// deleteModel = id => this.fetch({ url: apiUrl.USER_MANAGE.DEVICE_MODEL_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 设备型号图片上传
	uploadImg = data => this.fetch({ url: apiUrl.USER_MANAGE.UPLOAD_IMG, method: 'post', data });

	// 用户导入模板下载
	downloadTemp = data => this.fetch({ url: apiUrl.USER_MANAGE.USER_TEMPLATE, method: 'post', data });

	// @observable detail = {};
	// @action
	// setDetail = data => this.detail = data;

	// getDetail = data => {
	//     const { id } = data;
	//     return this.fetch({
	//         url: joinUrl(apiUrl.DEVICE.DETAIL, id),
	//         method: 'get',
	//         setState: "setDetail",
	//         data
	//     });
	// }


	// activate = data => this.fetch({ url: apiUrl.DEVICE.ACTIVATE, method: 'post', data }); // 激活
}
